import { useState, useEffect } from "react";

const useDataPostFunction = () => {
  const [response, setResponse] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); //different!
  const [controller, setController] = useState();
  const [detailedError, setDetailedError] = useState({})

  const axiosPost = async (configObj) => {
    const { axiosInstance, method, url, data, requestConfig = {} } = configObj;

    try {
      setLoading(true);
      const ctrl = new AbortController();
      setController(ctrl);
      const res = await axiosInstance[method.toLowerCase()](url, data, {
        ...requestConfig,
        signal: ctrl.signal,
      });
      setResponse(res);
    } catch (err) {
      setError(err.message);
      setDetailedError(err)
    } finally {
      setLoading(false);
    }
  };

  const resetPostResponse = () => {
    setResponse([]);
    setError("");
    setLoading(false);
    setDetailedError({})
  };

  useEffect(() => {
    // useEffect cleanup function
    return () => controller && controller.abort();
  }, [controller]);
  return [response, error, loading, axiosPost, detailedError, resetPostResponse];
};

export default useDataPostFunction;
